import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'

/**
* Radio input icon.
*/
function RadioIcon(props) {
  const { isOn, ...rest } = props

  return (
    <Icon
      icon={isOn ? 'radio-on' : 'radio-off'}
      aria-hidden
      role="presentation"
      {...rest}
    >
      {
        isOn
        ? (<g><path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" /></g>)
        : (<g><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" /></g>)
      }
    </Icon>
  )
}

RadioIcon.defaultProps = {
  isOn: false,
}

RadioIcon.propTypes = {
  isOn: PropTypes.bool,
}

export default RadioIcon
